import { Controller } from "@hotwired/stimulus"
import closeOtherDropdowns from "./close_other_dropdowns"

export default class extends Controller {
  static targets = ["menu", "button", "placeholder", "clearButton"]
  
  connect() {
    // Close dropdown when clicking outside
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
    document.addEventListener("keydown", this.boundHandleKeydown)
    this.setOpen(this.hasMenuTarget && !this.menuTarget.classList.contains("hidden"))
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  toggle(event) {
    if (this.buttonTarget.disabled) {
      return
    }
    event.stopPropagation()

    // Close all other dropdowns
    closeOtherDropdowns(this.application, this.element)

    if (this.hasMenuTarget) {
      this.setOpen(this.menuTarget.classList.contains("hidden"))
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
  
  select(event) {
    const value = event.currentTarget.dataset.value
    const filterType = this.element.dataset.filterType
    
    // Update main form's hidden field
    const form = this.element.closest('form')
    const hiddenInput = form.querySelector(`input[name="${filterType}"]`)
    if (hiddenInput) {
      hiddenInput.value = value
    }
    
    // Update visual state
    this.placeholderTarget.textContent = event.currentTarget.textContent
    this.placeholderTarget.classList.remove('text-gray-500')
    this.placeholderTarget.classList.add('text-black', 'font-semibold')
    if (this.hasMenuTarget) {
      this.setOpen(false)
    }
    
    // Show clear button
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.remove('hidden')
    }
    
    // Submit the form
    form.submit()
  }
  
  clear(event) {
    event.preventDefault()
    const filterType = this.element.dataset.filterType
    
    // Update main form's hidden field
    const form = this.element.closest('form')
    const hiddenInput = form.querySelector(`input[name="${filterType}"]`)
    if (hiddenInput) {
      hiddenInput.value = ''
    }
    
    // Reset UI state
    this.resetUI()
    
    // Submit the form
    form.submit()
  }
  
  resetUI() {
    this.placeholderTarget.textContent = this.buttonTarget.dataset.defaultText || 'Operacijos tipas'
    this.placeholderTarget.classList.add('text-gray-500')
    this.placeholderTarget.classList.remove('text-black', 'font-semibold')
    if (this.hasMenuTarget) {
      this.setOpen(false)
    }
    
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.add('hidden')
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && this.hasMenuTarget) {
      this.setOpen(false)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      event.preventDefault()
      this.close()
      this.buttonTarget.focus()
    }
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    if (!this.hasMenuTarget || !this.hasButtonTarget) return

    this.menuTarget.classList.toggle("hidden", !open)
    this.buttonTarget.setAttribute("aria-expanded", open.toString())
  }
}
